export default {
      id: "icon-cash-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-cash",
      toString: function () {
        return this.url;
      }
    }